const layoutDirection = (language) => {
	const rtlLanguages = ['ar'];

	return rtlLanguages.includes(language) ? 'rtl' : 'ltr';
};

export { layoutDirection };
